import { render } from "./FornitoriDataTable.vue?vue&type=template&id=5209aab2&scoped=true"
import script from "./FornitoriDataTable.vue?vue&type=script&lang=js"
export * from "./FornitoriDataTable.vue?vue&type=script&lang=js"

import "./FornitoriDataTable.vue?vue&type=style&index=0&id=5209aab2&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5209aab2"]])

export default __exports__